// 环境配置文件
const environments = {
  development: {
    name: '开发环境',
    apiBaseUrl: 'http://localhost:3000/api',
    environment: 'development',
    debug: true,
    features: {
      analytics: false,
      logging: true,
      experimental: true
    }
  },
  staging: {
    name: '测试环境',
    apiBaseUrl: 'https://staging-api.amis.hk',
    environment: 'staging',
    debug: true,
    features: {
      analytics: true,
      logging: true,
      experimental: true
    }
  },
  production: {
    name: '生产环境',
    apiBaseUrl: 'https://api.amis.hk',
    environment: 'production',
    debug: false,
    features: {
      analytics: true,
      logging: false,
      experimental: false
    }
  }
};

// 根据当前环境获取配置
const getCurrentEnvironment = () => {
  const env = process.env.NODE_ENV || 'development';
  return environments[env] || environments.development;
};

// 导出配置
export const config = getCurrentEnvironment();

// 导出环境信息
export const isDevelopment = config.environment === 'development';
export const isStaging = config.environment === 'staging';
export const isProduction = config.environment === 'production';

// 导出功能开关
export const features = config.features;

export default config; 